const ITEMS = [
  "NEED × OPPORTUNITY",
  "PERSON × PERSON",
  "BUSINESS × CUSTOMER",
  "PROBLEM × SOLUTION",
  "IDEA × EXPERTISE",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative border-y border-white/10 bg-[#06090F] py-7 overflow-hidden select-none"
  >
    <div className="flex whitespace-nowrap animate-marquee will-change-transform">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center shrink-0" aria-hidden={dup === 1}>
          {ITEMS.map((t, i) => (
            <span key={`${dup}-${i}`} className="flex items-center">
              <span
                className={`font-display font-bold uppercase text-2xl sm:text-4xl tracking-tight px-10 ${
                  i % 2 === 0 ? "text-slate-200" : "text-outline"
                }`}
              >
                {t}
              </span>
              <span className="text-[#00F0FF] text-lg sm:text-2xl font-light">✕</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
